/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateMemoRequestDto } from '../models/create-memo-request-dto';
import { UserVerificationDto } from '../models/user-verification-dto';
import { UserVerificationMemoDto } from '../models/user-verification-memo-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedUserVerificationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createManualVerification
   */
  static readonly CreateManualVerificationPath = '/api/user-verifications';

  /**
   * Creates a manual user verification in manual review state. Quite hacky...
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createManualVerification()` instead.
   *
   * This method doesn't expect any request body.
   */
  createManualVerification$Response(params?: {
    userId?: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserVerificationDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserVerificationService.CreateManualVerificationPath, 'post');
    if (params) {
      rb.query('userId', params.userId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserVerificationDto>;
      })
    );
  }

  /**
   * Creates a manual user verification in manual review state. Quite hacky...
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createManualVerification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createManualVerification(params?: {
    userId?: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<UserVerificationDto> {

    return this.createManualVerification$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserVerificationDto>) => r.body as UserVerificationDto)
    );
  }

  /**
   * Path part for operation deleteUserVerification
   */
  static readonly DeleteUserVerificationPath = '/api/user-verifications/{id}';

  /**
   * Deletes an user verification including its uploaded documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUserVerification()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserVerification$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserVerificationService.DeleteUserVerificationPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes an user verification including its uploaded documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUserVerification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserVerification(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteUserVerification$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation createVerificationMemo
   */
  static readonly CreateVerificationMemoPath = '/api/user-verifications/{id}/memos';

  /**
   * Creates a memo for an existing verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVerificationMemo()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createVerificationMemo$Response(params: {
    id: number;
    'X-API-Version'?: string;
    body?: CreateMemoRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserVerificationMemoDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserVerificationService.CreateVerificationMemoPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserVerificationMemoDto>;
      })
    );
  }

  /**
   * Creates a memo for an existing verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVerificationMemo$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createVerificationMemo(params: {
    id: number;
    'X-API-Version'?: string;
    body?: CreateMemoRequestDto
  },
  context?: HttpContext

): Observable<UserVerificationMemoDto> {

    return this.createVerificationMemo$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserVerificationMemoDto>) => r.body as UserVerificationMemoDto)
    );
  }

  /**
   * Path part for operation deleteVerificationMemo
   */
  static readonly DeleteVerificationMemoPath = '/api/user-verifications/{id}/memos/{memoId}';

  /**
   * Deletes a memo from an existing verification. This method is quite fake and just marks a memo as deleted, but doesn't actually delete it ... so just assume its kind of a patch.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVerificationMemo()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVerificationMemo$Response(params: {
    id: number;
    memoId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserVerificationService.DeleteVerificationMemoPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('memoId', params.memoId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes a memo from an existing verification. This method is quite fake and just marks a memo as deleted, but doesn't actually delete it ... so just assume its kind of a patch.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVerificationMemo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVerificationMemo(params: {
    id: number;
    memoId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteVerificationMemo$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
